module.exports = __webpack_public_path__ + "9d5df3464b4900af448d2465afdf0ac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ModulesLanding/module4.png
// module id = 1381
// module chunks = 0